import * as Yup from "yup";

// helper for yup transform function
function emptyStringToNull(
  value: string | number,
  originalValue: string | number,
) {
  if (originalValue === "") {
    return null;
  }

  return value;
}

const schema = Yup.object().shape({
  search: Yup.string(),
  locations: Yup.array().of(
    Yup.object({
      name: Yup.string().required(),
      bedCount: Yup.number()
        .label("Bed count")
        .min(0)
        .max(9999)
        .transform(emptyStringToNull)
        .nullable(),
    }),
  ),
});

export default schema;
